// Host-side ports published by docker-compose. Override in tmc-local-frontend/.env
// (VUE_APP_BACKEND_PORT / VUE_APP_AUTH_PORT) to match BACKEND_HOST_PORT /
// AUTH_HOST_PORT in the repo-root .env when those defaults are already taken.
const BACKEND_PORT = process.env.VUE_APP_BACKEND_PORT || '3000';
const AUTH_PORT = process.env.VUE_APP_AUTH_PORT || '3001';

const prodUrlRe = /(http[s]?):\/\/([a-zA-Z0-9-]*)\.local\.tmconsulting\.dev/;

/**
 * Which county this browser is looking at, from the host it was served from.
 *
 * The same subdomain that names auth and backend above. Anything needing to identify the county to
 * something outside this app - the County Toolkit's setup codes, which carry it in a filename so a
 * desk knows which auth service to redeem against - should read it here rather than re-deriving it.
 *
 * Empty on a docker-compose port-based origin, where there is no county in the URL at all.
 */
export const countySlug = (href = window.location.href) => {
  const matches = String(href).match(prodUrlRe);
  return matches && matches.length === 3 ? matches[2] : '';
};

export const configUrls = () => {
  const URLS = {
    AUTH_GQL: '',
    AUTH_REST: '',
    BACKEND_GQL: '',
    BACKEND_REST: '',
  };
  if (window.location.href.indexOf('http://') !== -1
    && window.location.href.match(/:500[0-9]/)) {
    const hostName = window.location.href.match(/^http:\/\/([a-zA-Z0-9.]+):500[0-9]/);
    // when using docker-compose
    URLS.AUTH_GQL = `http://${hostName[1]}:${AUTH_PORT}/graphiql`;
    URLS.AUTH_REST = `http://${hostName[1]}:${AUTH_PORT}/`;
    URLS.BACKEND_GQL = `http://${hostName[1]}:${BACKEND_PORT}/graphiql`;
    URLS.BACKEND_REST = `http://${hostName[1]}:${BACKEND_PORT}/api`;
  } else {
    const matches = window.location.href.match(prodUrlRe);
    if (matches && matches.length === 3) {
      const protocol = matches[1];
      const countyName = matches[2];
      URLS.AUTH_GQL = `${protocol}://auth.${countyName}.local.tmconsulting.dev/graphiql`;
      URLS.AUTH_REST = `${protocol}://auth.${countyName}.local.tmconsulting.dev`;
      URLS.BACKEND_GQL = `${protocol}://backend.${countyName}.local.tmconsulting.dev/graphiql`;
      URLS.BACKEND_REST = `${protocol}://backend.${countyName}.local.tmconsulting.dev/api`;
    } else {
      console.error('Unable to set dependent URLs!');
    }
  }
  return URLS;
};

export default {
  configUrls,
  countySlug,
};
